import axios from "axios";
import React from "react";
import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Pages/React/Main";
import "../css/custom_font.css";
import "@mantine/core/styles.css";
import "@mantine/core/styles/global.css";
import "@mantine/core/styles/Divider.css";
import "../css/global.css";
import { ColorSchemeScript } from "@mantine/core";
import Intro from "./Pages/React/Intro";
import Thanks from "./Pages/React/Thanks";
import Display from "./Pages/Pages/Display";
// Setup CSRF tokens.
axios.defaults.xsrfCookieName = "csrfToken";
axios.defaults.xsrfHeaderName = "X-Csrf-Token";

const el = document.getElementById("app");
if (!el) {
    throw new Error("Could not find application root element");
}

createInertiaApp({
    // turn progress indicator off by seting this to false
    progress: true,
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props }) {
        createRoot(el).render(
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/brochure/:tour_id/intro"
                        element={<Intro />}
                    />
                    <Route
                        path="/brochure/:tour_id/:page?/:day?/*"
                        element={<App {...props}></App>}
                    />
                    <Route
                        path="/brochure/:tour_id/thanks"
                        element={<Thanks />}
                    />
                    <Route path="/" element={<Display />} />
                </Routes>
                <ColorSchemeScript />
            </BrowserRouter>
        );
    },
});
